'use strict';/* global define */define('modules/core/modules/toaster/directives/toaster/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
controller.$inject = ["Toaster"];
function controller(Toaster){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.toasts=Toaster.queue();ctrl.dismiss=Toaster.remove;}module.exports=controller;});
